"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledInputContainer = exports.StyledColorSquare = exports.StyledRequiredStar = exports.StyledValueBlueSpan = exports.StyledValue = exports.StyledValueWrapper = exports.StyledSelectItem = exports.StyledItemsWrapper = exports.StyledSelectDrawer = exports.StyledArrow = exports.StyledNotion = exports.StyledField = exports.StyledLabel = exports.StyledLabelWrapper = exports.StyledSearch = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const vobaza_ui_inputs_input_text_1 = require("@nebo-team-dev/vobaza.ui.inputs.input-text");
exports.StyledSearch = (0, styled_components_1.default)(vobaza_ui_inputs_input_text_1.InputText) `
  width: 100%;
  min-height: 40px;
  font-weight: 500;
  padding: 4px 40px 4px 12px;
  height: 40px;
  position: relative;

  & label {
    font-size: 8px;
  }
`;
exports.StyledLabelWrapper = styled_components_1.default.div `
  position: absolute;
  top: 14px;
  left: 12px;
  right: 36px;
  display: flex;

  font-size: 14px;
  line-height: 20px;
  color: #909090;

  transition: 0.3s;
  transition-property: top, color, opacity, font-size, font-weight, line-height;
`;
exports.StyledLabel = styled_components_1.default.label `
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
`;
exports.StyledField = styled_components_1.default.div `
  position: relative;
`;
exports.StyledNotion = styled_components_1.default.div `
  margin: 0 13px;
  font-size: 12px;
  line-height: 18px;
  color: ${(props) => props.hasError ? 'var(--error-color, #e73030)' : '#909090'};
`;
exports.StyledArrow = styled_components_1.default.div `
  position: absolute;
  top: 14px;
  right: 12px;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  outline: none;
  z-index: 1;

  svg {
    color: ${({ disabled }) => disabled ? '#909090' : 'var(--primary-color, #367BF5)'};
  }

  &:hover {
    opacity: 0.8;

    + .input {
      border: 1px solid #909090;
    }
  }

  &:active {
    opacity: 0.5;
  }
`;
exports.StyledSelectDrawer = styled_components_1.default.div `
  margin-top: 2px;
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  width: 100%;
  max-height: 300px;
  padding: 12px 0;
  background: #ffffff;
  box-shadow: 0px 4px 8px rgba(138, 118, 92, 0.16);
  border-radius: 8px;
  z-index: 2;
  overflow: hidden;
`;
exports.StyledItemsWrapper = styled_components_1.default.div `
  max-height: 180px;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: #ebebeb;
    border-radius: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #909090;
    border-radius: 8px;
  }
`;
exports.StyledSelectItem = styled_components_1.default.div `
  display: flex;
  align-items: center;
  padding: 4px 12px;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  ${(props) => {
    if (props.disabled == true)
        return `
      pointer-events: none;
      cursor: default;
    `;
}}

  &:hover {
    background: var(--primary-color-hover, #e1ebfd);
  }
`;
exports.StyledValueWrapper = styled_components_1.default.div `
  display: flex;
  overflow: hidden;
  width: 100%;
`;
exports.StyledValue = styled_components_1.default.span `
  display: block;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;
exports.StyledValueBlueSpan = styled_components_1.default.span `
  flex-shrink: 0;
  margin-left: 5px;
  color: var(--primary-color, #319cf8);
`;
exports.StyledRequiredStar = styled_components_1.default.span `
  position: relative;
  left: 2px;
  color: #e73030;
`;
exports.StyledColorSquare = styled_components_1.default.div `
  flex-shrink: 0;
  margin-right: 8px;
  box-sizing: border-box;
  width: 24px;
  height: 24px;
  background: ${(props) => props.color};
  border: 1px solid #fafafa;
`;
exports.StyledInputContainer = styled_components_1.default.div `
  position: relative;
  z-index: 1;
  display: flex;
  box-sizing: border-box;
  padding: 19px 42px 3px 12px;
  width: 100%;
  min-width: 200px;
  min-height: 48px;
  border: 1px solid;
  border-color: ${(props) => props.hasError ? 'var(--error-color, #e73030)' : '#ebebeb'};
  border-radius: 8px;
  color: var(--dark, #212121);
  font-size: 14px;
  line-height: 20px;
  background: transparent;
  outline: none;
  cursor: pointer;

  &:hover {
    border: 1px solid;
    border-color: ${(props) => props.hasError ? 'var(--error-color, #e73030)' : '#909090'};
    cursor: pointer;
  }

  &.focus {
    outline: 0;
    cursor: pointer;
    border: 1px solid;
    border-color: ${(props) => props.hasError ? 'var(--error-color, #e73030)' : '#909090'};

    + .labelWrapper {
      top: 2px;
    }

    + .labelWrapper {
      font-size: 12px;
      line-height: 18px;
      cursor: default;
    }

    + .labelWrapper ${exports.StyledRequiredStar} {
      font-size: 11px;
    }
  }

  &.disabled {
    border: 1px solid #ebebeb;
    background-color: #ebebeb;
    cursor: default;

    + ${exports.StyledLabelWrapper} {
      cursor: default;
      z-index: 1;
      pointer-events: none;

      + ${exports.StyledArrow} {
        pointer-events: none;
      }
    }
  }
`;
//# sourceMappingURL=input-select.styled.js.map